import styles from '../myReviews.module.css';
import EditIcon from '../../icons/edit_review.svg';
import starTransparent from '../../icons/star-transparent.svg';
import starColor from '../../icons/star-color.svg';
import { memo } from 'react';
import Rating from 'react-rating';
import { useNavigate } from 'react-router-dom';

const MyReview = ({ triggerReviewEditPopup, hotelData, setHotelID, setGooglePlaceId }) => {
    const navigate = useNavigate();
    const hotelRoute = hotelData.hotel.placeId
        ? `/hotelreview?googlePlaceId=${hotelData.hotel.placeId}`
        : `/hotelreview?hotelID=${hotelData.hotel.id}`;

    return (
        <div className={styles.wrapper}>
            <div className={styles.top_inner}>
                <div className={styles.rev_rating}>
                    <span className={styles.rating}>{(Object.entries(hotelData.review.Rates).reduce((sum, [key, value]) => sum + value.rates, 0) / 5).toFixed(1)}</span>
                    <Rating
                        initialRating={Object.entries(hotelData.review.Rates).reduce((sum, [key, value]) => sum + value.rates, 0) / 10}
                        stop={5}
                        emptySymbol={<img src={starTransparent} className={styles.starIcon} alt='' />}
                        fullSymbol={<img src={starColor} className={styles.starIcon} alt='' />}
                        readonly
                    />
                </div>
                <img src={EditIcon} alt="Edit" onClick={() => {
                    triggerReviewEditPopup();
                    setHotelID(hotelData.review.hotelID || null)
                    setGooglePlaceId(hotelData.review.googlePlaceId || null)
                }} />
            </div>
            <div role="button" onClick={() => navigate(hotelRoute)} style={{ cursor: 'pointer' }}>
                <div className={styles.hotel_info_wrapper}>
                    <p>{hotelData.hotel.name}</p>
                    <p>{hotelData.hotel.location}</p>
                </div>
                <ul className={styles.list}>
                    {Object.entries(hotelData.review.Rates.sort((a, b) => a.RateCriterium.name.localeCompare(b.RateCriterium.name))).map(([key, value]) => (
                        <li key={key}>
                            <p>{value.RateCriterium.name}: <strong>{value.rates}</strong> </p>
                        </li>
                    ))}
                    <li>
                        <p>Overall: <strong>{Object.entries(hotelData.review.Rates).reduce((sum, [key, value]) => sum + value.rates, 0) / 5}</strong></p>
                    </li>
                </ul>
                <p className={styles.descr}>{hotelData.review.comment.slice(0, 55) + (hotelData.review.comment?.length > 55 ? '...' : '')}</p>
            </div>
        </div>
    );
};
export default memo(MyReview);
